<script>
import moment from 'moment';
import EventCard from './EventCard.vue';
import RelativeTime from '../RelativeTime/RelativeTime.vue';
import t from './state/types';
// + Implicit dependency on plugins/vue-moment.js

export default {
  name: 'FormSelections',
  components: {
    EventCard,
    RelativeTime,
  },
  props: {
    events: {
      type: Object,
      default: () => {},
    },
    sort: {
      type: String,
      default: t.SORT_TIME,
    },
    shortlist: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {
      sortedEvents: this.events,
    };
  },
  methods: {
    displayRunnerCard: function(selectionId) {
      this.$emit('displayRunnerCard', selectionId);
    },
    runnerCount: function(group) {
      let count = 0;

      group.forEach(event => (count += event.selections.length));

      return count;
    },
    eventOdds: function(eventId) {
      return Object.values(this.odds).filter(selection => selection.eventId === eventId);
    },
    groupName: function(name) {
      if (name === 'All') return name;

      return moment(name).calendar(null, {
        sameDay: '[Today]',
        nextDay: '[Tomorrow]',
        nextWeek: 'dddd',
        sameElse: 'dddd',
      });
    },
    shortlistSelection: function(selectionId, method = 'add') {
      this.$emit('shortlistSelection', selectionId, method);
    },
  },
};
</script>
<template>
  <div class="form-finder__results">
    <div
      v-for="(group, name) in events"
      :key="name"
      class="form-result-group"
    >
      <div class="form-result-group__heading">
        <h2>{{ groupName(name) }}</h2>
        <p>
          <span class="count"><span>{{ runnerCount(group) }}</span> matching runners</span>
        </p>
      </div>
      <EventCard
        v-for="event in group"
        :key="event.id"
        :id="event.id"
        :meeting="event.meetingName"
        :number="event.number"
        :date="event.startsAt"
        :selections="event.selections"
        :shortlist="shortlist"
        :url="event.url"
        @displayRunnerCard="displayRunnerCard"
        @shortlistSelection="shortlistSelection"
      />
    </div>
  </div>
</template>
